export default {
  homeTitle: "Philips light calculator",
  homeSubTitle: "Please select the calculations or conversions you would like to make below.",
  helloWorld: "English",
  solarRadiationCalculation: "Solar radiation calculation",
  greenhouseTransmission: "Greenhouse transmission",
  greenhouseTransmissionUnit: "(%)",
  greenhouseTransmissionToolTip:
    "The percentage of light to penetrate the greenhouse. In a modern Venlo greenhouse, the default value is 70%.",
  intensityOutside: "Intensity outside ",
  intensityOutsideUnit: "(W/m²)",
  intensityOutsideToolTip:
    "Calculate the amount of PAR light (inside) from the total light intensity (outside), and vise versa. <br> PAR light includes all light with a wavelength from 400 to 700 nm. Plants can use this light directly for photosynthesis.",
  prInside: "PAR inside",
  prInsideUnit: "(μmol/m²/sec)",
  prInsideToolTip:
    "Calculate the amount of PAR light (inside) from the total light intensity (outside), and vise versa. <br> PAR light includes all light with a wavelength from 400 to 700 nm. Plants can use this light directly for photosynthesis.",
  radiationSUM: "Radiation sum outside",
  radiationSUMUnit: "(J/cm²/day)",
  radiationSUMToolTip:
    "Calculate the sum of day light inside (in Mol) from the light sum outside (in Joules), and vise versa.",
  lightSUM: "Light sum inside",
  lightSUMUnit: "(mol/m²/day)",
  lightSUMToolTip:
    "Calculate the sum of day light inside (in Mol) from the light sum outside (in Joules), and vise versa.",
  luxToPar: "LUX-PAR converter",
  luxToParInfo: "In this calculation, the LUX value is based on an average HPS spectrum.",
  LUX: "LUX",
  LUXToolTip:
    "The unit LUX is often used to express the intensity of HPS lighting",
  PAR: "PAR",
  PARUnit: "(μmol/m²/sec)",
  PARToolTip:
    "PAR light includes all light with a wavelength from 400 to 700 nm. Plants can use this light directly for photosynthesis.",
  ali: "Assimilation light intensity (HPS and LED)",
  aliMaxLighting: "Lighting hours",
  aliMaxLightingUnit: "(daily)",
  aliMaxLightingToolTip:
    "The desired day length for the crop (e.g. 18 hours for tomatoes).",
  unit: "LUX or micromol",
  lightIntensityMicro: "Light intensity",
  lightIntensityMicroUnit: "(μmol/m²/sec)",
  lightIntensityMicroToolTip: "Intensity assimilation lighting.",
  lightIntensityHPSLED: "Light intensity",
  lightIntensityHPSLEDUnit: "(HPS/LED)",
  lightIntensityHPSLEDToolTip: "Intensity assimilation lighting.",
  lightIntensitySUM: "Light sum",
  lightIntensitySUMUnit: "(mol/m²/day)",
  lightIntensitySUMToolTip: "Resulting supplemental light intensity per day.",
  requiredSuplementalLightLevel: "Indication required supplemental light level",
  targetDaily: "Target daily light integral",
  targetDailyUnit: "(mol/m²/day)",
  targetDailyToolTip:
    "The desired amount of PAR light to be received by the crop per day.",
  supplementMaxLight: "Lighting hours ",
  supplementMaxLightUnit: "(daily)",
  supplementMaxLightToolTip:
    "The desired day length for the crop (e.g. 18 hours for tomatoes).",
  naturelLight: "Natural light inside",
  naturelLightUnit: "(mol/m²/day)",
  naturelLightToolTip:
    'The amount of day light penetrating into the greenhouse. This can be calculated using the "Solar radiation calculation".',
  supplementLight: "Indication required supplemental light level",
  supplementLightUnit: "(μmol/m²/sec)",
  supplementLightToolTip:
    "This number shows the supplemental lighting intensity which is required to reach the desired daily light integral (DLI).",
  copyToClipboard: "Copy URL to clipboard",
  exportToXLSX: "Export to Excel file",
  connectWithPhilips: "Connect with Philips",
  investorRelations: "Investor relations",
  careers: "Careers",
  contactPhilips: "Contact Philips",
  siteOwner: "Site owner",
  cookiesNotice: "Cookies notice",
  privacyNotice: "Privacy notice",
  productSecurity: "Product security",
  termsOfUse: "Terms of use",
  copyright: "© 2019-{n} Signify Holding. All rights reserved.",
  country: "Country",
  language: "Global - English",
  exportCalculation: "Export calculations",
  copyURL: "URL copied to clipboard!"
};
